import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {API_URLS} from '../../../../../../../environments/env-routes';
import {APIHelper} from '../../../../../../../shared/services/api-helper/api-helper.service';

@Component({
  selector: 'app-dialog-edit-file',
  templateUrl: './dialog-edit-file.component.html',
  styleUrls: ['./dialog-edit-file.component.scss']
})
export class DialogEditFileComponent implements OnInit {
  public selectedId: string;
  public ariane;
  public loading: boolean;
  public file: any;
  public name: string;
  public description: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogEditFileComponent>,
    private api: APIHelper
  ) {}

  ngOnInit() {
    this.loading = false;
    this.file = this.data.file;
    this.selectedId = this.data.file.id;

    this.name = this.file.name;
    this.description = this.file.properties['cm:description'];
  }

  onValidate() {
    this.loading = true;

    const url = API_URLS.nodes.nodes.replace(':nodeId', this.selectedId);
    const data = {
      name: this.name,
      properties: {
        'cm:description': this.description,
        'cm:title': this.name
      }
    };
    const args =
      'include=path%2Cproperties%2CallowableOperations%2Cpermissions';

    this.api
      .requestApi({ action: url, method: 'PUT', datas: data, queryArgs: args })
      .then(res => {
        this.dialogRef.close(res);
      })
      .finally(() => (this.loading = false));
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
